import { WaterCheckIcon } from './WaterCheckIcon';

/**
 * author: Colton Wiscombe
 * id 30A9ED7F-3D06-476B-A4F1-B9F85786FF00
 * name water-check
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-check.svg
 * tags
 */
export const BloodCheckIcon = WaterCheckIcon;
export default BloodCheckIcon